/**
 * Shared diagnostics export utility.
 *
 * Extracted from LeftDiagnosticsPanel so the QuickActionLauncher's
 * "Diagnostics snapshot" entry hits EXACTLY the same JSON as the panel's
 * built-in export button. One source of truth.
 */

export function downloadDiagnosticsJson(diagnostics, sessionStartedAt) {
    if (!diagnostics || diagnostics.length === 0) return false;
    const base = sessionStartedAt ?? (diagnostics[0]?.ts ?? null);
    const enriched = diagnostics.map((d) => ({
        ts: d.ts,
        rel_ts_s: base ? (d.ts - base) / 1000 : 0,
        type: d.type,
        response_id: d.response_id ?? null,
        detail: d.detail ?? {},
    }));
    const blob = new Blob([JSON.stringify(enriched, null, 2)], {
        type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `qoryn-diagnostics-${new Date().toISOString().replace(/[:.]/g, "-")}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return true;
}
